import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import CheckCircleIcon from "@heroicons/react/24/solid/CheckCircleIcon";
import {
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import Color from "../../../assets/colors";

export const DialogStyled = styling(Dialog)({
  "& .MuiDialog-paper": {
    width: "100%",
    maxWidth: "35rem",
    borderRadius: "1rem",
    margin: "1rem",
  },
});

export const DialogTitleStyled = styling(DialogTitle)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "1.5rem 1.5rem 1rem",
});

export const DialogHeading = styling(Typography)({
  color: Color.black,
  fontFamily: "Inter",
  fontSize: "1.25rem",
  fontWeight: 700,
  lineHeight: "1.75rem",
});

export const CloseButton = styling(IconButton)({
  color: Color.black,
  padding: "0.25rem",
});

export const CloseIconStyled = styling(XMarkIcon)({
  width: "1.5rem",
  height: "1.5rem",
});

export const DialogContentStyled = styling(DialogContent)({
  padding: "0 1.5rem 1.5rem",
});

export const DialogDescription = styling(Typography)({
  color: Color.black,
  fontFamily: "Inter",
  fontSize: "0.875rem",
  lineHeight: "1.25rem",
  marginBottom: "1rem",
});

export const UploadArea = styling("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.75rem",
  minHeight: "12rem",
  padding: "1.5rem",
  border: `2px dashed ${Color.grey}`,
  borderRadius: "0.75rem",
  textAlign: "center",
});

export const UploadButton = styling(ButtonBase)({
  color: Color.white,
  backgroundColor: Color.hiredlyPurple,
  borderRadius: "2rem",
  padding: "0.75rem 1.5rem",
  fontFamily: "Inter",
  fontSize: "0.875rem",
  fontWeight: 700,

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.darkPurple,
    },
  },
});

export const SupportedFileText = styling(Typography)({
  color: Color.grey,
  fontFamily: "Inter",
  fontSize: "0.75rem",
  lineHeight: "1rem",
});

export const SelectedFileText = styling(Typography)({
  maxWidth: "100%",
  overflow: "hidden",
  color: Color.black,
  fontFamily: "Inter",
  fontSize: "0.875rem",
  fontWeight: 600,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const HiddenFileInput = styling("input")({
  display: "none",
});

export const ErrorText = styling(Typography)({
  color: Color.error,
  fontFamily: "Inter",
  fontSize: "0.75rem",
  lineHeight: "1rem",
  textAlign: "center",
});

export const ExistingResumeContainer = styling("div")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  padding: "1rem",
  border: `1px solid ${Color.grey}`,
  borderRadius: "0.75rem",
});

export const ResumeActionContainer = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  flexWrap: "wrap",
});

export const OutlineActionButton = styling(ButtonBase)({
  color: Color.black,
  backgroundColor: Color.white,
  border: `2px solid ${Color.black}`,
  borderRadius: "2rem",
  padding: "0.625rem 1.25rem",
  fontFamily: "Inter",
  fontSize: "0.875rem",
  fontWeight: 700,

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.lightGrey,
    },
  },
});

export const ReuploadNote = styling(Typography)({
  color: Color.darkGrey,
  fontFamily: "Inter",
  fontSize: "0.75rem",
  fontWeight: 600,
  lineHeight: "1.125rem",
});

export const SuccessToastContent = styling("div")({
  fontFamily: "Inter",
});

export const SuccessToastHeader = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const SuccessToastIcon = styling(CheckCircleIcon)({
  width: "24px",
  height: "24px",
  flexShrink: 0,
  color: "#90B938",
});

export const SuccessToastTitle = styling("div")({
  color: "#000000",
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: "28px",
});

export const SuccessToastMessage = styling("div")({
  marginTop: "12px",
  color: "#707070",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
});

export const ResumeSentToastContainer = styling(ToastContainer)({
  "&.Toastify__toast-container": {
    width: "min(520px, calc(100vw - 32px))",
  },

  "& .company-resume-sent-toast": {
    width: "100%",
    minHeight: "96px",
    padding: "18px 20px 18px 28px",
    border: "none",
    borderLeft: "6px solid #90B938",
    borderRadius: "12px",
    color: "#000000",
    backgroundColor: "#FFFFFF",
    boxShadow: "4px 4px 16px rgba(0, 0, 0, 0.20)",

    "& .Toastify__toast-body": {
      padding: 0,
      margin: 0,
    },

    "&. Toastify__close-button": {
      alignSelf: "flex-start",
      marginTop: "4px",
      color: "#707070",
      opacity: 1,
    },

    "& .Toastify__progress-bar--wrp": {
      display: "none",
    },
  },
});
